import { ArticleCard } from "@/components/ArticleCard";

export const CaseStudyCard = (props) => {
  return <ArticleCard type="Case Study" {...props} />;
};
